module.exports = __webpack_public_path__ + "static/img/award-9.bce60ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/award-9.jpg
// module id = DOl4
// module chunks = 1